export default defineNuxtPlugin((nuxtApp) => {
  const { fetchDirectMessageCounts, unreadCount: directMessageUnreadCount } = useDirectMessageCounts

  nuxtApp.hook("app:navigated", () => {
    fetchDirectMessageCounts()
  })
})
